/**
 * ヘッダー検索キーワードの履歴を localStorage に永続化する純粋関数群。
 *
 * 未ログインでも保持するため Shopify customer ではなく localStorage に保存する。
 * 並走中の v1 検索履歴と区別するためキーに `_v2` を付与する。
 */

export const KEYWORD_HISTORY_STORAGE_KEY = 'keyword_search_history_v2';
export const KEYWORD_HISTORY_LIMIT = 10;

function safeReadArray(key: string): string[] {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is string => typeof v === 'string' && v.length > 0);
  } catch {
    return [];
  }
}

function safeWriteArray(key: string, value: string[]): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // QuotaExceeded 等は黙殺（履歴は best-effort）
  }
}

export function readKeywordHistory(limit?: number): string[] {
  const items = safeReadArray(KEYWORD_HISTORY_STORAGE_KEY);
  if (typeof limit === 'number' && limit >= 0) {
    return items.slice(0, limit);
  }
  return items;
}

/**
 * 重複を除去してから先頭に挿入し、上限件数で切り詰める。
 * 空文字・空白のみの場合は no-op。
 */
export function pushKeywordHistory(
  keyword: string,
  limit: number = KEYWORD_HISTORY_LIMIT,
): void {
  const trimmed = keyword.trim();
  if (!trimmed) return;
  const current = safeReadArray(KEYWORD_HISTORY_STORAGE_KEY);
  const deduped = current.filter((k) => k !== trimmed);
  deduped.unshift(trimmed);
  const next = deduped.slice(0, limit);
  safeWriteArray(KEYWORD_HISTORY_STORAGE_KEY, next);
}

export function removeKeywordHistory(keyword: string): void {
  const current = safeReadArray(KEYWORD_HISTORY_STORAGE_KEY);
  const next = current.filter((k) => k !== keyword);
  safeWriteArray(KEYWORD_HISTORY_STORAGE_KEY, next);
}

export function clearKeywordHistory(): void {
  try {
    localStorage.removeItem(KEYWORD_HISTORY_STORAGE_KEY);
  } catch {
    // 黙殺
  }
}
